import { z } from 'zod'
import type { TopicNetworkResponse } from '../model/contracts'

const graphNodeSchema = z.object({
  id: z.string(),
  label: z.string(),
  type: z.string(),
  group: z.string(),
  influence: z.number(),
  color: z.string(),
})

const graphLinkSchema = z.object({
  source: z.string(),
  target: z.string(),
  weight: z.number(),
  sentiment: z.string(),
})

const graphGroupSchema = z.object({
  key: z.string(),
  label: z.string(),
  color: z.string(),
  count: z.number(),
})

const networkGraphStatsSchema = z.object({
  authors: z.number(),
  comments: z.number(),
  groups: z.number(),
  links: z.number(),
})

const topicNetworkResponseSchema = z.object({
  nodes: z.array(graphNodeSchema),
  links: z.array(graphLinkSchema),
  groups: z.array(graphGroupSchema),
  stats: networkGraphStatsSchema,
})

export function parseTopicNetworkResponse(data: unknown): TopicNetworkResponse {
  const result = topicNetworkResponseSchema.safeParse(data)
  if (!result.success) {
    console.error('TopicNetworkResponse validation failed:', z.treeifyError(result.error))
    console.error('Raw payload:', data)
    throw new Error('Invalid TopicNetworkResponse contract')
  }
  return result.data
}
